import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '../ui/button';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { Menu, Phone } from 'lucide-react';
import { companyInfo } from '../../data/mock';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { href: '/', label: 'Startseite' },
    { href: '/vergleich', label: 'Finanzierungsvergleich' },
    { href: '/anfrage', label: 'Anfrage stellen' },
    { href: '/beratung', label: 'Beratung' },
    { href: '/ueber-uns', label: 'Über uns' },
    { href: '/faq', label: 'FAQ' },
    { href: '/kontakt', label: 'Kontakt' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm">
      <div className="mx-auto w-full max-w-7xl px-4">
        <div className="flex h-16 lg:h-20 items-center gap-6">
          {/* Left: Logo */}
          <Link to="/" className="flex items-center gap-2 shrink-0">
            <img
              src="https://customer-assets.emergentagent.com/job_loan-compare-2/artifacts/cfzo1i0k_%7B2DFB527A-B0B8-42B3-A709-3F13FA3C1A27%7D.png"
              alt={companyInfo.name}
              className="w-8 h-8 sm:w-10 sm:h-10 object-contain"
            />
            <span className="text-lg sm:text-xl font-bold text-slate-800 whitespace-nowrap">
              {companyInfo.name}
            </span>
          </Link>

          {/* Middle: Desktop Navigation (flexible + centered) */}
          <nav className="hidden lg:flex flex-1 items-center justify-center gap-1 min-w-0">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-3 xl:px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  isActive(link.href)
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-slate-600 hover:text-blue-700 hover:bg-slate-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          {/* Right: CTA + Mobile */}
          <div className="flex items-center gap-3 shrink-0 whitespace-nowrap">
            <Link to="/anfrage" className="hidden sm:block">
              <Button className="bg-blue-600 hover:bg-blue-700 text-white shadow-md hover:shadow-lg transition-all">
                Jetzt anfragen
              </Button>
            </Link>

            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild className="lg:hidden">
                <Button variant="ghost" size="icon" className="text-slate-700">
                  <Menu className="w-6 h-6" />
                </Button>
              </SheetTrigger>

              <SheetContent side="right" className="w-80 bg-white">
                <div className="flex flex-col h-full">
                  <div className="flex items-center gap-2 py-4 border-b">
                    <img
                      src="https://customer-assets.emergentagent.com/job_loan-compare-2/artifacts/cfzo1i0k_%7B2DFB527A-B0B8-42B3-A709-3F13FA3C1A27%7D.png"
                      alt={companyInfo.name}
                      className="w-8 h-8 object-contain"
                    />
                    <span className="text-lg font-bold text-slate-800">{companyInfo.name}</span>
                  </div>

                  <nav className="flex flex-col gap-1 py-6">
                    {navLinks.map((link) => (
                      <Link
                        key={link.href}
                        to={link.href}
                        onClick={() => setIsOpen(false)}
                        className={`px-4 py-3 rounded-lg text-base font-medium transition-all ${
                          isActive(link.href)
                            ? 'bg-blue-50 text-blue-700'
                            : 'text-slate-600 hover:text-blue-700 hover:bg-slate-50'
                        }`}
                      >
                        {link.label}
                      </Link>
                    ))}
                  </nav>

                  <div className="mt-auto pb-6">
                    <Link to="/anfrage" onClick={() => setIsOpen(false)}>
                      <Button className="w-full bg-blue-600 hover:bg-blue-700 text-white">
                        Jetzt anfragen
                      </Button>
                    </Link>

                    <div className="mt-4 text-center">
                      <a
                        href={`tel:${companyInfo.contact.phone}`}
                        className="flex items-center justify-center gap-2 text-slate-600 whitespace-nowrap"
                      >
                        <Phone className="w-4 h-4" />
                        <span className="whitespace-nowrap">{companyInfo.contact.phone}</span>
                      </a>
                    </div>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
